import { DateHelper, DomClassList, MessageDialog, PaperFormat, StringHelper, Toast } from "@bryntum/gantt/gantt.module";
import { translate } from "./translate";
import dayjs from "dayjs";
import { getColumnId } from "../pages/Settings/components/Columns/configs";
import { snackbar } from "../redux/snackbar";
import { Box, Button } from "@mui/material";


function taskCantBeRemovedToast() {
  Toast.show({
    html: translate("removeRidderTask"),
    timeout: 5000,
  });
}

function taskCantBeRemovedUseUndoToast() {
  Toast.show({
    html: translate("removeSplitTask"),
    timeout: 5000,
  });
}

export function sameDay(d1, d2) {
  return d1.getFullYear() === d2.getFullYear() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getDate() === d2.getDate();
}

export function getYesNoColumnFilter(field) {
  return {
    filterField: {
      type: "combo",
      editable: false,
      items: ["Yes", "No"],
    },

    filterFn: ({ record, value }) => {
      if (!value) {
        return true;
      }
      if (value === "Yes" && record[field]) {
        return true;
      }
      return value === "No" && !record[field];
    },
  };
}

export function applyColumnFilters(columnFilters, taskStore) {
  return new Promise((res) => {
    if (columnFilters) {
      for (const filter of columnFilters) {
        taskStore.addFilter(filter);
      }
    }
    res();
  });
}

export function mergeColumns(configColumns = {}, defaultColumns) {
  const columns = defaultColumns.reduce((res, item) => {
    const key = getColumnId(item);
    const conf = configColumns[key] || {};
    res[key] = {
      ...item,
      ...conf,
      text: item.text || conf.text,
      field: item.field,
      type: item.type,
    };
    if (res[key].field === undefined) {
      delete res[key].field;
    }
    return res;
  }, {});

  const columnsList = Object.values(columns);
  columnsList.sort((a, b) => {
    return b.order - a.order;
  });
  return columnsList;
}
export function getScrollToTaskContextMenu() {
  return {
    icon: "b-fa b-fa-external-link-alt",
    text: "L{Go to task}",
    onItem: async ({ taskRecord, eventRecord, source }) => {
      const record = taskRecord || eventRecord;
      const hist = source.partners.find((i) => i.$$name === "ResourceHistogram");
      await source.scrollToDate(record.startDate, { block: "start", animate: true });
      if (hist && hist.isVisible !== false) {
        const level = hist.zoomLevel;
        await hist.zoomToLevel(hist.zoomLevel > 1 ? hist.zoomLevel - 1 : hist.zoomLevel + 1);
        await hist.zoomToLevel(level);
      }
    },
  };
}

export function getHeaderContextMenu() {
  return {
    processItems: ({ items }) => {
      console.log(items);
      if (items.columnPicker?.menu?.items) {
        items.columnPicker.menu.items.sort((a, b) => 
          (a.text || '').localeCompare(b.text || '', undefined, { sensitivity: 'base' })
        );
      }
      return items;
    },
  };
}

export function getEditTask() {
  return {
    icon: "b-icon b-icon-edit",
    onItem({ eventRecord }) {
      window.scheduler.editEvent(eventRecord);
    },
    text: "L{Gantt.Edit}",
  };
}

export function getSplitTaskByHourContextMenu(useSplitIcons) {
  return {
    icon: "b-fa b-fa-clock",
    text: "L{splitTaskByHourText}",
    menu: {
      items: [
        {
          type: "number",
          placeholder: "L{splitTaskByHourPlaceholder}",
          name: "hourSplitInput",
        },
        {
          text: "L{Apply split}",
          style: "text-align: center;margin: 0 10px 10px;",
          cls: "b-green b-button",
          onItem({ taskRecord, eventRecord, menu }) {
            const { splitTaskByHours } = menu.widgetMap;
            const items = Object.values(splitTaskByHours.menu.widgetMap);
            const hourSplitInput = items.find((i) => i.name === "hourSplitInput");
            const value = hourSplitInput.value;
            const record = taskRecord || eventRecord;

            const hours = record.effort;
            if (!value) {
              let toast = new Toast({
                color: "b-orange",
                html: translate("splitTaskValueEmpty"),
              });

              toast.show();
              return;
            }
            if (hours > value) {
              const splitPoint = 1 / (hours / value);
              splitTask(record, splitPoint, useSplitIcons);
            } else {
              let toast = new Toast({
                color: "b-orange",
                timeout: 8000,
                html: translate("splitTaskValueInvalid", {
                  value,
                  hours,
                }),
              });

              toast.show();
            }
          },
        },
      ],
    },
  };
}

export function getOpenTaskDetailsItem() {
  return {
    icon: "b-fa b-fa-link",
    text: "L{Open project details}",
    onItem: async ({ taskRecord, eventRecord }) => {
      const record = taskRecord || eventRecord;
      const url = new URL("/project/" + record.projectID, document.location.origin);
      url.searchParams.set("targetTask", record.id);
      window.open(url.toString(), "_blank");
    },
  };
}

export function getUnDoSplitTaskContextMenu() {
  return {
    icon: "b-fa b-fa-undo",
    text: "L{undoSplit}",
    onItem: async ({ taskRecord, eventRecord }) => {
      taskRecord = taskRecord ?? eventRecord;
      const taskStore = taskRecord.taskStore;
      const original = taskStore.getById(taskRecord.get("OriginalLineID"));
      const assignmentsData = (original.assignments || []).map((i) => {
        return {
          id: i.id,
          units: i.units,
        };
      });
      if (original) {
        const effort = original.effort + taskRecord.effort;
        assignmentsData.forEach((item, index) => {
          original.assignments[index].units = item.units;
        });
        original.effort = effort;

        await taskStore.commitAsync(); //First commit the changed effort, incase we cannot update the duration because of planning conflicts


        const duration = original.duration + taskRecord.duration;              
        original.duration = duration;       
      }

 
      let allSplitParts = taskStore.query(record => (record.projectID == original.projectID) && ((record.OriginalLineID ?? record.id) == original.id), true);
      allSplitParts.sort((a, b) => a.segmentSeqNr - b.segmentSeqNr);
      for (let split of allSplitParts) {
        if (split.segmentSeqNr >= taskRecord.segmentSeqNr && split.id != original.id) {
          split.segmentSeqNr = split.segmentSeqNr - 1;
        }
      }
      
      if (allSplitParts.length == 2) { //When undoing the last split
        original.isSplit = false;
        original.iconCls = "";
      }

      taskRecord.undoSplit = true;
      await taskStore.commitAsync();
      taskRecord.remove();
    },
  };
}

function setRollupAllChildren(taskRecord, rollup) {
  taskRecord.rollup = rollup;
  if (!taskRecord.children) {
    return;
  }

  for (const childTask of taskRecord.children) {
    setRollupAllChildren(childTask, rollup);
  }
}

export function getRollupContextMenu(useSplitIcons) {
  const me = this;
  return {
    icon: "b-fa b-fa-paint-roller",
    text: "L{Rollup all subtasks}", 
    menu: [
      {
        text: "L{Activate}",
        onItem: async ({ taskRecord }) => {
          setRollupAllChildren(taskRecord, true);
          gantt.renderContents();
        },
      },
      {
        text: "L{Deactivate}",
        onItem: async ({ taskRecord, eventRecord }) => {
          setRollupAllChildren(taskRecord, false);
          gantt.renderContents();
        },
      },
    ],
  };
}

export function getSplitTaskContextMenu(useSplitIcons) {
  return {
    icon: "b-fa b-fa-cut",
    text: "L{splitTask}",
    menu: [
      {
        text: "at 25%",
        onItem: async ({ taskRecord, eventRecord }) => {
          taskRecord = taskRecord ?? eventRecord;
          splitTask(taskRecord, 0.25, useSplitIcons);
        },
      },
      {
        text: "at 50%",
        onItem: async ({ taskRecord, eventRecord }) => {
          taskRecord = taskRecord ?? eventRecord;
          splitTask(taskRecord, 0.5, useSplitIcons);
        },
      },
      {
        text: "at 75%",
        onItem: async ({ taskRecord, eventRecord }) => {
          taskRecord = taskRecord ?? eventRecord;
          splitTask(taskRecord, 0.75, useSplitIcons);
        },
      },
    ],
  };
}

export function getParentRecursively(record) {
  let parent = record;
  // eslint-disable-next-line no-constant-condition
  while (true) {
    if (!parent) {
      return null;
    }
    if (parent?.ERPWbs === "1") {
      return parent;
    }
    parent = parent.parent;
  }
}
export function updateTasksColor(projectTask) {
  const subTasks = [projectTask, ...flatTasks(projectTask.children)];
  projectTask.taskStore.beginBatch();
  subTasks.forEach((i) => {
    const cls = i.cls.value.split(" ");
    const index = cls.findIndex((i) => i.startsWith("bgcolor-"));
    const color = i.taskBarColor || projectTask.taskBarColor || i.departmentTaskBarColor;
    const newClass = "bgcolor-" + color;
    if (index > -1) {
      cls[index] = "bgcolor-" + color;
    } else {
      cls.push(newClass);
    }
    i.cls = new DomClassList(cls.join(" "));
  });
  projectTask.taskStore.endBatch();
}
export function getProjectColorContextMenu() {
  return {
    icon: "b-fa b-fa-palette",
    text: "ProjectColor",
    menu: {
      onItem: async ({ taskRecord, item }) => {
        taskRecord.set({
          taskBarColor: item.color,
        });
        await taskRecord.commitAsync();
        updateTasksColor(taskRecord);
      },
      items: [].concat(ganttColors).map((i) => ({
        color: i,
        text: `<div>
                <span style="vertical-align:middle;display:inline-block;width:16px;height:16px;background: ${i};margin-right:8px;"></span>
                <span>${i}</span>
            </div>`,
      })),
    },
  };
}

export function getAddMilestoneContextMenu() {
  return {
    icon: "b-fa b-fa-flag",
    text: "Milestone",
    onItem: async ({ taskRecord }) => {
      const createdTask = await window.gantt.addMilestoneBelow(taskRecord);
      createdTask.RidderType = ridderTypes.R_PROJECTMILESTONE;
      //TODO: use the gantt ref instead of the window
    },
  };
}

export function changeToFullFixedUnits() {
  return {
    icon: "b-fa b-fa-flag",
    text: "L{changeTo100Units}",
    async onItem({ eventRecord, taskRecord }) {
      const record = eventRecord || taskRecord;
      record.set("schedulingMode", "FixedEffort");
      const assignments = record.assignments || [];
      assignments.forEach((assignmentRecord) => assignmentRecord.set("units", 100));
      await record.commitAsync();
      const store = assignments[0];
      if (store) {
        await store.commitAsync();
      }
    },
  };
}

function copySplitTaskDependencies(originalTask, newTask) {
  for (let dep of originalTask.dependencies) {
    const fromEventId = dep.fromEvent?.id ?? dep.fromTask?.id;
    const toEventId = dep.toEvent?.id ?? dep.toTask?.id;
    if (originalTask.id == fromEventId) {
      //Dependency from the original task to be splitted --> another task
      newTask.dependencyStore.add({
        lag: dep.lag,
        lagUnit: dep.lagUnit,
        fromEvent: newTask,
        toEvent: dep.toEvent,
        type: dep.type,
      });
    } else if (originalTask.id == toEventId) {
      //Dependency from another task --> the original task to be splitted
      newTask.dependencyStore.add({
        lag: dep.lag,
        lagUnit: dep.lagUnit,
        fromEvent: dep.fromEvent,
        toEvent: newTask,
        type: dep.type,
      });
    }
  }
}

function setSplitDurationAndDates(originalTask, newTask, splitPoint, originalStartDate, originalEndDate, originalDuration, originalEffort) {
  let lockStart = false;
  let lockEnd = false;
  
  let originDuration = Math.ceil(originalDuration * splitPoint);
  let newDuration = originalDuration - originDuration;
  if (newDuration < 1) {
    newDuration = 1;
    if (originDuration >= 2) {
      originDuration--;
    }
  }
  const originEffort = originalEffort * splitPoint;
  const newEffort = originalEffort * (1 - splitPoint);

  for (let dep of originalTask.dependencies) {
    const fromEventId = dep.fromEvent?.id ?? dep.fromTask?.id;
    const toEventId = dep.toEvent?.id ?? dep.toTask?.id;
    if (originalTask.id == fromEventId) {
      if (dep.type == 0 || dep.type == 1) { //dependency based on the split task start date, so the start date cannot change
        lockStart = true;
      }
    } else if (originalTask.id == toEventId) {
      if (dep.type == 1 || dep.type == 3) { //dependency based on the split task end date, so the end date cannot change
        lockEnd = true;
      }
    }
  }

  if (lockStart && lockEnd) {
    originDuration = originalDuration;
    newDuration = originalDuration;
  }

  //Adjust duration and effort, but keep the original startdate
  originalTask.setDuration(originDuration, originalTask.durationUnit);
  originalTask.setEffort(originEffort);
  originalTask.setStartDate(new Date(originalStartDate), true);
 
  newTask.setDuration(newDuration, originalTask.durationUnit);
  newTask.setEffort(newEffort);
  newTask.setStartDate(new Date(originalStartDate), true);

  //Adjust date fields
  if (lockStart && lockEnd) {
    newTask.setEndDate(new Date(originalEndDate));
  } else if (lockStart) {
    //No action needed, both tasks start at the original start date
  }
  else if (lockEnd) {
    originalTask.setEndDate(new Date(originalEndDate), true);
  } else {
    newTask.setEndDate(new Date(originalEndDate), true);
  }
}

async function splitTask(splitTask, splitPoint, useSplitIcons) {
  const originalId = splitTask.get("OriginalLineID") || splitTask.id;
  const taskStore = splitTask.taskStore;
  const originalDuration = splitTask.duration % 1 < 0.01 ? Math.round(splitTask.duration) : Math.ceil(splitTask.duration);
  let originalStartDate = new Date(splitTask.startDate.toString());
  let originalEndDate = new Date(splitTask.endDate);
  if (originalEndDate.getHours() !== 23 || originalEndDate.getMinutes() !== 59) {
    originalEndDate = new Date(originalEndDate.setHours(23, 59));
  }
  const originalEffort = splitTask.effort || 0;
  const assignments = splitTask.assignments;
  const assignmentsData = assignments.map((i) => {
    return {
      id: i.id,
      units: i.units,
    };
  });

  //Split the task and move it to the correct position in the project
  taskStore.beginBatch();
  const newTask = splitTask.split(splitPoint);
  newTask.undoSplit = true;
  newTask.set("OriginalLineID", originalId);
  newTask.set("SplitFromID", splitTask.id); //Is not saved to the database only used during the creation of the split task
  taskStore.move(newTask, splitTask);
  taskStore.move(splitTask, newTask);
  taskStore.endBatch();

  setSplitDurationAndDates(splitTask, newTask, splitPoint, originalStartDate, originalEndDate, originalDuration, originalEffort);
  copySplitTaskDependencies(splitTask, newTask);

  newTask.undoSplit = false;
  assignmentsData.forEach((item, index) => {
    splitTask.assignments[index].units = item.units;
    newTask.assignments[index].units = item.units;
  });

  newTask.segmentSeqNr = splitTask.segmentSeqNr + 1;
  let originalID = splitTask.OriginalLineID ?? splitTask.id;
  let allSplitParts = taskStore.query(record => (record.projectID == splitTask.projectID) && ((record.OriginalLineID ?? record.id) == originalID), true);
  allSplitParts.sort((a, b) => a.segmentSeqNr - b.segmentSeqNr);
 
  for (let split of allSplitParts) {
    split.isSplit = true;
    if (useSplitIcons) {
      split.iconCls = "b-fa b-fa-cut";
    }     
    if (split.segmentSeqNr >= newTask.segmentSeqNr && split.id != newTask.id) {
      split.segmentSeqNr = split.segmentSeqNr + 1;
    }
  }
  
  await taskStore.commitAsync(); 

  //set splittask id as a property in the newtask for the backend save action
  newTask.refProjectLineDepartmentView = originalId;
  newTask.createdBySplitTask = true;
}

export const flatTasks = (tasks, projectColor) => {
  return tasks.reduce((tasks, task) => {
    task.projectColor = typeof projectColor === "undefined" ? task.taskBarColor : projectColor || null; // add initial project color
    if (typeof task.startDate === "string") {
      task.startDate = new Date(task.startDate);
    }
    if (typeof task.endDate === "string") {
      task.endDate = new Date(task.endDate);
    }
    tasks.push(task);
    if (task.children) {
      const subTasks = flatTasks(task.children, task.projectColor);
      tasks = tasks.concat(subTasks);
    }
    return tasks;
  }, []);
};

export const tasksIdList = (result, tasks) => {
  tasks.forEach((task) => {
    result[task.id] = task;
    if (task.children) {
      tasksIdList(result, task.children);
    }
  });
  return result;
};

/**
 * set duration for a task that is not milestone to prevent bryntum convert it to milestone
 * @param tasks {[{}]}
 */
export function setMinDurationToPreventBeMilestone(tasks) {
  tasks.forEach((task) => {
    if (task.RidderType === ridderTypes.R_PROJECTBUDGETDETAIL) {
      return;
    }
    let start = new Date(task.startDate);
    let end = new Date(task.endDate);

    const duration = DateHelper.diff(start, end, "day");
    if (duration > 2) {
      return; // Milestone prevention is not needed for tasks longer than a weekend
    }

    if (
      (!task.duration || task.duration === 0) &&
      !task.milestone &&
      (!task.children || (task.children && task.children.length === 0))
    ) {
      let startDay = start.getDay();
      let endDay = end.getDay(); 
      if ((startDay == 0 || startDay == 6) && (endDay == 0 || endDay == 6)) {
        if (endDay == 0) {
          task.endDate = new Date(end.setDate(end.getDate() + 1));
        } else {
          task.endDate = new Date(end.setDate(end.getDate() + 2));
        }
      }       
      
    }
  });
}

export function addDeadlineDateToTasks(tasks) {
  tasks.forEach((task) => {
    if (task.deadlineDate) {
      task.deadlineDate = new Date(task.deadlineDate);
    }
  });
}

export function addDependencyLimitDatesToTasks(tasks) {
  tasks.forEach((task) => {
    if (task.previousDependencyEndDate) {
      task.previousDependencyEndDate = new Date(task.previousDependencyEndDate);
    }
    if (task.nextDependencyStartDate) {
      task.nextDependencyStartDate = new Date(task.nextDependencyStartDate);
    }
  });
}

export const ganttColors = [
  "",
  "MidnightBlue",
  "RoyalBlue",
  "CornflowerBlue",
  "DeepSkyBlue",
  "LightBlue",
  "LightSteelBlue",
  "CadetBlue",
  "PaleTurquoise",
  "LightSeaGreen",
  "YellowGreen",
  "Khaki",
  "AliceBlue",
  "Tan",
  "BlanchedAlmond",
  "OliveDrab",
  "ForestGreen",
  "AntiqueWhite",
  "Aqua",
  "Aquamarine",
  "Azure",
  "Beige",
  "Bisque",
  "Black",
  "Blue",
  "BlueViolet",
  "Brown",
  "BurlyWood",
  "Chartreuse",
  "Chocolate",
  "Coral",
  "Cornsilk",
  "Crimson",
  "Cyan",
  "DarkBlue",
  "DarkCyan",
  "DarkGoldenRod",
  "DarkGray",
  "DarkGreen",
  "DarkKhaki",
  "DarkMagenta",
  "DarkOliveGreen",
  "Darkorange",
  "DarkOrchid",
  "DarkRed",
  "DarkSalmon",
  "DarkSeaGreen",
  "DarkSlateBlue",
  "DarkSlateGray",
  "DarkTurquoise",
  "DarkViolet",
  "DeepPink",
  "DimGray",
  "DodgerBlue",
  "FireBrick",
  "FloralWhite",
  "Fuchsia",
  "Gainsboro",
  "GhostWhite",
  "Gold",
  "GoldenRod",
  "Gray",
  "Green",
  "GreenYellow",
  "HoneyDew",
  "HotPink",
  "IndianRed",
  "Indigo",
  "Ivory",
  "Lavender",
  "LavenderBlush",
  "LawnGreen",
  "LemonChiffon",
  "LightCoral",
  "LightCyan",
  "LightGoldenRodYellow",
  "LightGray",
  "LightGrey",
  "LightGreen",
  "LightPink",
  "LightSalmon",
  "LightSkyBlue",
  "LightSlateGray",
  "LightSlateGrey",
  "LightYellow",
  "Lime",
  "LimeGreen",
  "Linen",
  "Magenta",
  "Maroon",
  "MediumAquaMarine",
  "MediumBlue",
  "MediumOrchid",
  "MediumPurple",
  "MediumSeaGreen",
  "MediumSlateBlue",
  "MediumSpringGreen",
  "MediumTurquoise",
  "MediumVioletRed",
  "MintCream",
  "MistyRose",
  "Moccasin",
  "NavajoWhite",
  "Navy",
  "OldLace",
  "Olive",
  "Orange",
  "OrangeRed",
  "Orchid",
  "PaleGoldenRod",
  "PaleGreen",
  "PaleVioletRed",
  "PapayaWhip",
  "PeachPuff",
  "Peru",
  "Pink",
  "Plum",
  "PowderBlue",
  "Purple",
  "Red",
  "RosyBrown",
  "SaddleBrown",
  "Salmon",
  "SandyBrown",
  "SeaGreen",
  "SeaShell",
  "Sienna",
  "Silver",
  "SkyBlue",
  "SlateBlue",
  "SlateGray",
  "Snow",
  "SpringGreen",
  "SteelBlue",
  "Teal",
  "Thistle",
  "Tomato",
  "Turquoise",
  "Violet",
  "Wheat",
  "White",
  "WhiteSmoke",
  "Yellow",
];

export const ridderTypes = {
  R_MAINPROJECT: "R_MAINPROJECT",
  R_PROJECTMILESTONE: "R_PROJECTMILESTONE",
  R_PROJECTPHASE: "R_PROJECTPHASE",
  R_ORDER: "R_ORDER",
  R_PROJECTBUDGETDETAIL: "R_PROJECTBUDGETDETAIL",
  R_SUBORDER: "R_SUBORDER",
  R_JOBORDER: "R_JOBORDER",
  R_JOBORDERDETAILWORKACTIVITY: "R_JOBORDERDETAILWORKACTIVITY",
};

export const beforeAddTask = ({ records }) => {
  records?.forEach((record) => {
    record.effort = record.effort ?? 0;
    record.taskBarColor = record.taskBarColor ?? "";
    record.RidderKey = record.RidderKey ?? null;
    record.duration = record.duration ?? 1;
    record.RidderType = record.RidderType ?? ridderTypes.R_PROJECTBUDGETDETAIL;
  });
};

export const updateTask = ({ record, source, changes }) => {
  if (!record.milestone && changes.hasOwnProperty("endDate")) {
    const value = changes["endDate"].value;
    if (!value) {
      // with resize the new value can become null
      record.endDate = changes["endDate"].oldValue;
      record.commitAsync();
      return;
    }
    let endOfDay = new Date(value.getFullYear(), value.getMonth(), value.getDate(), 23, 59);

    let timeDiffSeconds = parseInt((endOfDay - value) / 1000);
    //12 hours = 12*60*60 = 43,200 hours
    if (timeDiffSeconds >= 60) {
      if (timeDiffSeconds > 43200) {
        endOfDay.setDate(endOfDay.getDate() - 1);
      }
      record.endDate = endOfDay;
      source.commitAsync();
    }
    if (timeDiffSeconds <= -60) {
      if (timeDiffSeconds < -43200) {
        endOfDay.setDate(endOfDay.getDate() + 1);
      }
      record.endDate = endOfDay;
      source.commitAsync();
    }
  }
};

//Help method to find a specific task in the task tree structure
export const getTaskById = (task, id) => {
  if (task.id == id) {
    return task;
  }
  if (task.children) {
    for (const childTask of task.children) {
      const resTask = getTaskById(childTask, id);
      if (resTask) {
        return resTask;
      }
    } 
  }
  return null;
};

/** @param {unknown[]|null|undefined} loadedTaskRoots */
export function getLoadedTaskJsonById(loadedTaskRoots, taskId) {
  if (!loadedTaskRoots?.length) {
    return null;
  }
  for (let i = 0; i < loadedTaskRoots.length; i++) {
    const found = getTaskById(loadedTaskRoots[i], taskId);
    if (found) {
      return found;
    }
  }
  return null;
}

/**
 * Leaf tasks only: if Bryntum scheduling moved start/end vs loaded JSON snapshot, mark those fields dirty for save/sync.
 * @param {*} project Bryntum ProjectModel
 * @param {unknown[]|null|undefined} loadedTaskRoots
 * @returns {boolean}
 */
export function markPropagatedTaskDatesDirtyComparedToLoadedJson(project, loadedTaskRoots) {
  const taskStore = project?.taskStore;
  if (!taskStore || !loadedTaskRoots?.length) {
    return false;
  }
  let marked = false;
  taskStore.allRecords.forEach((record) => {
    if (record.blocked || !record.id || (!!record.children && record.children.length > 0)) {
      return;
    }
    const taskJson = getLoadedTaskJsonById(loadedTaskRoots, record.id);
    if (!taskJson) {
      return;
    }

    let startDrift = false;
    if (taskJson.startDate) {
      const loadedStart = new Date(taskJson.startDate);
      const currentStart = record.startDate ? new Date(record.startDate) : null;
      if (
        currentStart &&
        !Number.isNaN(loadedStart.getTime()) &&
        !Number.isNaN(currentStart.getTime()) &&
        !sameDay(currentStart, loadedStart)
      ) {
        startDrift = true;
      }
    }

    let endDrift = false;
    if (taskJson.endDate) {
      const loadedEnd = new Date(taskJson.endDate);
      const currentEnd = record.endDate ? new Date(record.endDate) : null;
      if (
        currentEnd &&
        !Number.isNaN(loadedEnd.getTime()) &&
        !Number.isNaN(currentEnd.getTime()) &&
        !sameDay(currentEnd, loadedEnd)
      ) {
        endDrift = true;
      }
    }

    if (!startDrift && !endDrift) {
      return;
    }

    const fieldsMarked = [];
    if (startDrift) {
      record.storeFieldChange("startDate", new Date(taskJson.startDate));
      fieldsMarked.push("startDate");
    }
    if (endDrift) {
      record.storeFieldChange("endDate", new Date(taskJson.endDate));
      fieldsMarked.push("endDate");
    }
    if (!taskStore.modified.includes(record)) {
      taskStore.modified.add(record);
    }
    const taskName = record.name != null ? String(record.name) : "";
    // console.log(
    //   "Propagated schedule vs loaded JSON: marked dirty",
    //   { taskId: record.id, taskName, fields: fieldsMarked }
    // );
    marked = true;
  });
  return marked;
}

export  const beforeUpdateTask = async ({ source, record, changes }) => {
  if(record?.isProjectModel){ //since bryntum version 6.1.6 this event sometimes triggers on the project model ignore this
    return;
  }
  
  if (record.blocked && (changes.hasOwnProperty("startDate") || changes.hasOwnProperty("endDate"))) {
    return false;
  }

  if (!record.blocked && !record.milestone && (changes.hasOwnProperty("startDate") || changes.hasOwnProperty("endDate"))) {
      let endDateChanged = false;
      let startDateChanged = false;
      let newStartDate = changes.startDate ?? record.startDate;
      let newEndDate = changes.endDate ?? record.endDate;

    //The end date should be at the end of the day 23:59, but only correct child tasks, parents will follow automatically
    if (changes.endDate && (changes.endDate.getHours() !== 23 || changes.endDate.getMinutes() !== 59)
      && record.children > 0) {
      newEndDate = new Date(changes.endDate.setHours(23, 59));
      endDateChanged = true;
    }    

    //Prevent the end date from becoming larger than the nextDependencyStartDate
    if(changes.endDate && record.nextDependencyStartDate && newEndDate > record.nextDependencyStartDate ){
      newEndDate = new Date(record.nextDependencyStartDate);
      endDateChanged = true;
    }

    //Prevent the start date from becoming smaller than the previousDependencyEndDate
    if(changes.startDate && record.previousDependencyEndDate && newStartDate < record.previousDependencyEndDate){
      newStartDate = new Date(record.previousDependencyEndDate);
      startDateChanged = true;
    }

    //Apply the date changes without breaking the task scheduling logic
    if(startDateChanged && endDateChanged){
      record.setStartDate(newStartDate, false);
      record.setEndDate(newEndDate, false);
    }else if(startDateChanged){
      record.setStartDate(newStartDate, true); //keep duration
    }else if(endDateChanged){
      record.setEndDate(newEndDate, true); //keep duration
    }

    if(startDateChanged || endDateChanged){
      //Check if the update with keep duration worked. otherwise update without keep duration (This happens if there is not enough room to move the task)
      let result = await record.taskStore.commitAsync();
      if(record.endDate && record.nextDependencyStartDate && record.endDate > record.nextDependencyStartDate){
        record.setEndDate(newEndDate, false);
      }else if(record.startDate && record.previousDependencyEndDate && record.startDate < record.previousDependencyEndDate){
        record.setEndDate(newStartDate, false);
      }
    }
  }
};

export const beforeRemoveTask = ({ records, removingAll, isMove }) => {
  let returnValue;
  let blockedByOriginalLineID = false;
  if (removingAll || isMove) return;
  records.forEach((record) => {
    if (record.get("OriginalLineID") && !record.undoSplit) {
      blockedByOriginalLineID = true;
      returnValue = false;
    }
    if (record.RidderKey && !record.undoSplit) {
      returnValue = false;
    }
  });
  if (returnValue === false) {
    if (blockedByOriginalLineID) {
      taskCantBeRemovedUseUndoToast();
    } else {
      taskCantBeRemovedToast();
    }
  }
  return returnValue;
};

export function getConvertToMilestone() {
  return {
    onItem({ taskRecord }) {
      if (taskRecord.RidderLink === null || taskRecord.RidderLink === 0) {
        taskRecord.RidderType = ridderTypes.R_PROJECTMILESTONE;
        taskRecord.convertToMilestone();
      }
    },
  };
}

export function updateTaskbarColorClasses(task, color, projectColor) {
  let classList = new DomClassList(task.cls);
  let existingColorClass = null;
  classList.forEach((domClass) => {
    if (domClass.startsWith("bgcolor-")) {
      existingColorClass = domClass;
    }
  });

  if (existingColorClass) {
    classList.remove(existingColorClass)
  }
 
  if (color) { //Setting new taskcolor  
    classList.add("bgcolor-" + color);
  } else { //clear color and go back to project -> department -> default
    if (projectColor) {
      classList.add("bgcolor-" + projectColor);
    } else if (task.departmentTaskBarColor) {
      classList.add("bgcolor-" + task.departmentTaskBarColor);
    }
  }

  task.cls = classList;
}

export function updateProjectColorClasses(task, projectColor) {
  task.children?.forEach((record) => {
    if (!record.taskBarColor) {
      let classList = new DomClassList(record.cls);
      let existingColorClass = null;

      classList.forEach((domClass) => {
        if (domClass.startsWith("bgcolor-")) {
          existingColorClass = domClass;
        }        
      });

      if (existingColorClass) {
        classList.remove(existingColorClass)
      }
      if (projectColor) {
        classList.add("bgcolor-" + projectColor);
      } else if (record.departmentTaskBarColor) {
        classList.add("bgcolor-" + record.departmentTaskBarColor);
      }     
      record.cls = classList;
    }    

    if (record.children) {
      updateProjectColorClasses(record, projectColor);
    }
  });
}

export function addClasses(tasks, useProjectColor) {
  tasks.forEach((record) => {
    let color;
    if (useProjectColor) {
      color = record.taskBarColor || record?.projectColor || record.departmentTaskBarColor;
    } else {
      color = record.taskBarColor || record.departmentTaskBarColor;
    }
    if (color) {
      record.cls = new DomClassList(record.cls);
      record.cls.add(`bgcolor-${color}`);
    }
  });
}

export function addNoResizeAndDrag(tasks, flat = false, allowExplicit = true) {
  tasks.forEach((record) => {
    if (record.blocked || (allowExplicit && record.ExplicitAssignment)) {
      record.resizable = false;
      record.draggable = false;
    }
    if (record.inactive) {
      record.resizable = false;
      record.draggable = false;
      record.manuallyScheduled = true;
    }

    if (record.resizable === false) {
      record.cls = new DomClassList(record.cls);
      record.cls.add("no-resize");
    }
    if (flat !== true && record.children) {
      addNoResizeAndDrag(record.children, flat, allowExplicit);
    }
  });
}

export function addNoResizeAndDragInactiveOrBlocked(tasks) {
  tasks.forEach((record) => {
    if (record.inactive || record.blocked) {
      record.resizable = false;
      record.draggable = false;
    }
  });
}

export function addSplitIconCls(tasks) {
  tasks.forEach((record) => {
    if (record.isSplit) {
      record.iconCls = "b-fa b-fa-cut";
    }
  });
}

/**
 * @param task {{}}
 * @param departments {{[key: number]: boolean}}
 */
export const departmentExists = (task, departments) => {
  if (departments[task.FK_DEPARTMENT]) {
    return true;
  }
  return !!(task.children && task.children.find((i) => departmentExists(i, departments)));
};

//Sort the resources first by department, then by type, then by name
export const sortResourcesByDepartment = (a, b) => {
  if (a.departmentdescription === b.departmentdescription) {
    if (a.resourceType === b.resourceType) {
      if (a.name === b.name) {
        return 0;
      }
      return a.name > b.name ? 1 : -1;
    }
    return a.resourceType > b.resourceType ? 1 : -1;
  }
  return a.departmentdescription > b.departmentdescription ? 1 : -1;
};

export function prepareResources(resources) {
  const departments = {};
  resources.forEach((i) => {
    if (i.resourceType === 2) {
      departments[i.resourceObjectId] = i;
    }
  });
  Object.values(departments)
    .sort((a, b) => {
      if (a.sortOrder > b.sortOrder) {
        return 1;
      } else if (a.sortOrder < b.sortOrder) {
        return -1;
      }
      return a.name.localeCompare(b.name);
    })
    .forEach((i, index) => {
      i.departmentOrder = index;
      i.sortOrder = Number.POSITIVE_INFINITY;
    });
  return resources.map((i) => ({
    ...i,
    image: false,
    departmentOrder: departments[i.departmentId].departmentOrder,
    cls: i.resourceType === 2 ? "department-resource" : "",
  }));
}
export const departmentSortResources = (a, b) => {
  let depA = a.groupChildren.find((i) => i.resourceType == 2);
  let depB = b.groupChildren.find((i) => i.resourceType == 2);
  if (!depA) {
    depA = a.groupChildren[0];
  }
  if (!depB) {
    depB = b.groupChildren[0];
  }

  // Sort by departmentOrder first
  if (depA.departmentOrder < depB.departmentOrder) {
    return -1;
  } else if (depA.departmentOrder > depB.departmentOrder) {
    return 1;
  }

  // Sort by sortOrder within the same departmentOrder
  if (depA.sortOrder < depB.sortOrder) {
    return -1;
  } else if (depA.sortOrder > depB.sortOrder) {
    return 1;
  }

  // Sort by resourceType, with resourceType = 2 last in the group
  if (depA.resourceType === 2 && depB.resourceType !== 2) {
    return 1;
  } else if (depA.resourceType !== 2 && depB.resourceType === 2) {
    return -1;
  }

  // sort departments with same order
  if (depA.departmentdescription !== depB.departmentdescription) {
    return depA.departmentdescription.localeCompare(depB.departmentdescription);
  }

  // sort resources with same order
  if (depA.name !== depB.name) {
    return depA.name.localeCompare(depB.name);
  }
  return 0;
};

export const getViewPresets = () => [
  {
    timeResolution: {
      unit: "month",
      increment: 1,
    },
    headers: [
      {
        increment: 1,
        unit: "year",
        dateFormat: "YYYY",
      },
      {
        increment: 1,
        renderer(start) {
          return DateHelper.getShortNameOfUnit("quarter").toUpperCase() + (Math.floor(start.getMonth() / 3) + 1);
        },
        unit: "quarter",
      },
    ],
    id: "year-30by100",
    rowHeight: 24,
    name: "Years",
    tickWidth: 30,
    tickHeight: 100,
    resourceColumnWidth: 100,
    displayDateFormat: "ll",
    shiftUnit: "year",
    shiftIncrement: 1,
    defaultSpan: 1,
  },
  {
    id: "monthAndYear2",
    name: "Months2",
    rowHeight: 24,
    tickWidth: 80,
    tickHeight: 80,
    displayDateFormat: "ll",
    shiftUnit: "month",
    shiftIncrement: 1,
    defaultSpan: 12,
    timeResolution: {
      unit: "day",
      increment: 1,
    },
    headers: [
      {
        increment: 1,
        unit: "year",
        dateFormat: "YYYY",
      },
      {
        increment: 1,
        unit: "month",
        dateFormat: "MMM YYYY",
      },
    ],
    mainHeaderLevel: 1,
    columnLinesFor: 1,
  },
  {
    id: "monthAndYear",
    name: "Months",
    rowHeight: 24,
    tickWidth: 110,
    tickHeight: 110,
    displayDateFormat: "ll",
    shiftUnit: "month",
    shiftIncrement: 3,
    defaultSpan: 12,
    timeResolution: {
      unit: "day",
      increment: 1,
    },
    headers: [
      {
        increment: 1,
        unit: "year",
        dateFormat: "YYYY",
      },
      {
        increment: 1,
        unit: "month",
        dateFormat: "MMM YYYY",
      },
    ],
    mainHeaderLevel: 1,
    columnLinesFor: 1,
  },
  {
    id: "weekDateAndMonth",
    name: "Weeks 3",
    rowHeight: 24,
    tickWidth: 30,
    tickHeight: 40,
    displayDateFormat: "ll",
    shiftUnit: "week",
    shiftIncrement: 1,
    defaultSpan: 10,
    timeResolution: {
      unit: "day",
      increment: 1,
    },
    headers: [
      {
        increment: 1,
        unit: "month",
        dateFormat: "YYYY MMMM",
      },
      {
        increment: 1,
        unit: "week",
        dateFormat: "WW",
      },
    ],
    mainHeaderLevel: 1,
    columnLinesFor: 1,
  },
  {
    id: "weekDateAndMonth2",
    name: "Weeks 3.1",
    rowHeight: 24,
    tickWidth: 60,
    tickHeight: 60,
    displayDateFormat: "ll",
    shiftUnit: "week",
    shiftIncrement: 1,
    defaultSpan: 10,
    timeResolution: {
      unit: "day",
      increment: 1,
    },
    headers: [
      {
        increment: 1,
        unit: "month",
        dateFormat: "YYYY MMMM",
      },
      {
        increment: 1,
        unit: "week",
        dateFormat: "WW",
      },
    ],
    mainHeaderLevel: 1,
    columnLinesFor: 1,
  },
  {
    id: "weekNumbersPreset",
    rowHeight: 24,
    tickWidth: 100,
    tickHeight: 50,
    displayDateFormat: "ll",
    shiftUnit: "hour",
    shiftIncrement: 1,
    defaultSpan: 12,
    timeResolution: {
      unit: "day",
      increment: 1,
    },
    headers: [
      {
        increment: 1,
        unit: "month",
        dateFormat: "MMMM YYYY",
      },
      {
        increment: 1,
        unit: "week",
        dateFormat: "{week} WW",
      },
    ],
    mainHeaderLevel: 1,
    columnLinesFor: 1,
  },
  {
    id: "weekAndDayLetter",
    name: "Weeks 2",
    rowHeight: 24,
    tickWidth: 20,
    tickHeight: 40,
    displayDateFormat: "ll",
    shiftUnit: "week",
    shiftIncrement: 1,
    defaultSpan: 10,
    timeResolution: {
      increment: 1,
      unit: "day",
    },
    headers: [
      {
        increment: 1,
        unit: "week",
        dateFormat: "{week} WW",
      },
      {
        increment: 1,
        unit: "day",
        dateFormat: "d1",
      },
    ],
    mainHeaderLevel: 0,
    columnLinesFor: 1,
  },
  {
    id: "weekAndDayLetter1",
    name: "Weeks 2.5",
    rowHeight: 24,
    tickWidth: 40,
    tickHeight: 50,
    displayDateFormat: "ll",
    shiftUnit: "week",
    shiftIncrement: 1,
    defaultSpan: 10,
    timeResolution: {
      unit: "day",
      increment: 1,
    },
    headers: [
      {
        increment: 1,
        unit: "week",
        dateFormat: "{week} WW",
        verticalColumnWidth: 115,
      },
      {
        increment: 1,
        unit: "day",
        dateFormat: "d1",
        verticalColumnWidth: 25,
      },
    ],
    mainHeaderLevel: 0,
    columnLinesFor: 1,
  },
  {
    id: "weekAndDay-54by80",
    name: "Days",
    rowHeight: 24,
    tickWidth: 54,
    tickHeight: 80,
    displayDateFormat: "ll",
    shiftUnit: "day",
    shiftIncrement: 1,
    defaultSpan: 1,
    timeResolution: {
      unit: "day",
      increment: 1,
    },
    headers: [
      {
        increment: 1,
        unit: "week",
        dateFormat: "{week} WW",
      },
      {
        unit: "day",
        increment: 1,
        dateFormat: "DD MMM",
      },
    ],
    mainHeaderLevel: 0,
    columnLinesFor: 1,
  },
  {
    id: "weekAndDay",
    name: "Days",
    rowHeight: 24,
    tickWidth: 100,
    tickHeight: 80,
    displayDateFormat: "ll",
    shiftUnit: "day",
    shiftIncrement: 1,
    defaultSpan: 1,
    timeResolution: {
      unit: "day",
      increment: 1,
    },
    headers: [
      {
        increment: 1,
        unit: "week",
        dateFormat: "{week} WW",
      },
      {
        unit: "day",
        increment: 1,
        dateFormat: "DD MMM",
      },
    ],
    mainHeaderLevel: 0,
    columnLinesFor: 1,
  },
];

export function taskBarDepartmentTooltip(data) {
  // eslint-disable-next-line @typescript-eslint/no-this-alias
  const me = this;
  const taskRecord = data.taskRecord || data.eventRecord;
  const cantBeResized = taskRecord.inactive || taskRecord.ExplicitAssignment;
  const noResizeMsg = taskRecord.inactive ? translate("Inactive task") : translate("Explicit assignment");

  const name = taskRecord.name;
  return `
    ${name ? `<b style="font-weight: bold;">${StringHelper.encodeHtml(name)}</b>` : ""}
    <table border="0" cellspacing="0" cellpadding="0" class="tooltip-table">
    <tbody>
    ${
      cantBeResized
        ? `<tr style="color: #DA2E2EEC;"><td align="left">${noResizeMsg}: </td><td align="right">${translate(
            "resize&drag-disabled"
          )}</td></tr>`
        : ""
    }
    <tr><td>${me.L("L{Start}")}:</td><td align="right">${data.startClockHtml}</td></tr>
    ${
      taskRecord.milestone
        ? ""
        : `
        <tr><td>${me.L("L{End}")}:</td><td>${data.endClockHtml}</td></tr>
        <tr><td>Effort:</td><td align="right">${taskRecord.effort?.toLocaleString(undefined, {
          maximumFractionDigits: 1,
        })} ${DateHelper.getLocalizedNameOfUnit(taskRecord.effortUnit, taskRecord.effort !== 1)}</td></tr>
        <tr>
          <td>${me.L("L{Complete}")}: </td><td align="right"> ${taskRecord.renderedPercentDone}%</td>
        </tr>
        ${
          taskRecord.note
            ? `<tr>
            <td>${me.L("L{Note}")}: </td><td align="right"> ${taskRecord.note}</td>
          </tr>`
            : ""
        }
        <tr>
          <td>${me.L("L{EarlyStart}")}: </td>
          <td align="right"> ${dayjs(taskRecord.earlyStartDate).format("MMM DD, YYYY")}</td>
        </tr>
        <tr>
          <td>${me.L("L{LateEnd}")}: </td><td align="right"> ${dayjs(taskRecord.lateEndDate).format(
            "MMM DD, YYYY"
          )}</td>
        </tr>
    `
    }
    </tbody>
    </table>
      `;
}

export function taskBarTooltip(data, projectDetails) {
  // eslint-disable-next-line @typescript-eslint/no-this-alias
  const me = this;
  const taskRecord = data.taskRecord || data.eventRecord;
  const canMoveExplicit = projectDetails?.generalProjectSettings?.AllowToMoveExplicitAssignment !== false;
  const cantBeResized = taskRecord.inactive || (taskRecord.ExplicitAssignment && !canMoveExplicit);
  const noResizeMsg = taskRecord.inactive ? translate("Inactive task") : translate("Explicit assignment");

  const name = taskRecord.name;
  return `
    ${name ? `<b style="font-weight: bold;">${StringHelper.encodeHtml(name)}</b>` : ""}
    <table border="0" cellspacing="0" cellpadding="0" class="tooltip-table">
    <tbody>
    ${
      cantBeResized
        ? `<tr style="color: #DA2E2EEC;"><td align="left">${noResizeMsg}: </td><td align="right">${translate(
            "resize&drag-disabled"
          )}</td></tr>`
        : ""
    }
    <tr><td>${me.L("L{Start}")}:</td><td align="right">${data.startClockHtml}</td></tr>
    ${
      taskRecord.milestone
        ? ""
        : `
        <tr><td>${me.L("L{End}")}:</td><td>${data.endClockHtml}</td></tr>
        <tr><td>Effort:</td><td align="right">${taskRecord.effort?.toLocaleString(undefined, {
          maximumFractionDigits: 1,
        })} ${DateHelper.getLocalizedNameOfUnit(taskRecord.effortUnit, taskRecord.effort !== 1)}</td></tr>

        <tr>
          <td>${me.L("L{Complete}")}: </td><td align="right"> ${taskRecord.renderedPercentDone}%</td>
        </tr>
    `
    }
    </tbody>
    </table>
      `;
}

export function schedulerEventBarTooltip(data) {
  // eslint-disable-next-line @typescript-eslint/no-this-alias
  const me = this;
  const taskRecord = data.taskRecord || data.eventRecord;
  let parentDescription = taskRecord?.parent.description;
  if (taskRecord?.parent.CustomerName) {
    parentDescription += " - " + taskRecord?.parent.CustomerName
  }
  const name = taskRecord?.name;
  return `
    ${
      parentDescription
        ? `<b style="font-weight: bold;display: block;">${StringHelper.encodeHtml(parentDescription)}</b>`
        : ""
    }
    ${name ? `<b style="font-weight: bold;display: block;">${StringHelper.encodeHtml(name)}</b>` : ""}

    <table border="0" cellspacing="0" cellpadding="0" class="tooltip-table">
    <tbody>
    ${
      taskRecord.inactive
        ? `<tr style="color: #DA2E2EEC;"><td align="right">${translate(
            "Inactive task"
          )}: </td><td style="padding-left:8px;">${translate("resize&drag-disabled")}</td></tr>`
        : ""
    }
    <tr><td>${me.L("L{Start}")}:</td><td align="right">${data.startText}</td></tr>
    ${
      taskRecord.milestone
        ? ""
        : `
        <tr><td>${me.L("L{End}")}:</td><td align="right">${data.endText}</td></tr>
        <tr><td>Effort:</td><td align="right">${taskRecord.effort?.toLocaleString(undefined, {
          maximumFractionDigits: 1,
        })} ${DateHelper.getLocalizedNameOfUnit(taskRecord.effortUnit, taskRecord.effort !== 1)}</td>
        </tr>

        <tr>
          <td>${me.L("L{Complete}")}: </td><td align="right"> ${taskRecord.renderedPercentDone}%</td>
        </tr>
    ${
      taskRecord.note
        ? `<tr>
            <td>${me.L("L{Note}")}: </td><td align="right"> ${taskRecord.note}</td>
          </tr>`
        : ""
    }
    <tr>
      <td>${me.L("L{EarlyStart}")}: </td>
      <td align="right"> ${dayjs(taskRecord.earlyStartDate).format("MMM DD, YYYY")}</td>
    </tr>
    <tr>
      <td>${me.L("L{LateEnd}")}: </td><td align="right"> ${dayjs(taskRecord.lateEndDate).format("MMM DD, YYYY")}</td>
    </tr>
    `
    }
    </tbody>
    </table>
      `;
}

export const preventAddAssignmentsForOutsourced = (event) => {
  if (!event) return;
  const haveToCancelEvent = (event.records || []).find((record) => {
    let outsourced = record?.event?.outsourced;
    if (typeof outsourced !== "boolean") {
      outsourced = record?.data?.event?.outsourced;
    }
    return outsourced;
  });
  return !haveToCancelEvent;
};

export function compareWBS(recordA, recordB) {
  let listA = recordA?.split(".") || [];
  let listB = recordB?.split(".") || [];

  for (let i = 0; i < listA.length && i < listB.length; i++) {
    if (listA[i] !== listB[i]) {
      return parseInt(listA[i]) < parseInt(listB[i]) ? -1 : 1;
    }
  }

  return 0;
}

export const getMinMaxDate = (preset) => {
  let min = dayjs().startOf("day").add(-4, "week");
  let max = dayjs().startOf("day").add(11, "week");
  if ("year-30by100" === preset) {
    min = dayjs().startOf("day").add(-4, "week");
    max = dayjs().startOf("day").add(7, "year");
  } else if ("weekDateAndMonth" === preset) {
    min = dayjs().startOf("day").add(-4, "week");
    max = dayjs().startOf("day").add(13, "week");
  } else if ("weekAndDayLetter" === preset) {
    min = dayjs().startOf("day").add(-4, "week");
    max = dayjs().startOf("day").add(11, "week");
  } else if ("weekAndDay-54by80" === preset) {
    min = dayjs().startOf("day").add(-4, "week");
    max = dayjs().startOf("day").add(4, "week");
  }
  min = min.day(1).startOf("day");
  max = max.day(6).endOf("day");
  return [min.toDate(), max.toDate()];
};

export function getWorkingTime(hideWeekend) {
  if (!hideWeekend) {
    return { fromDay: 0, toDay: 7 };
  }
  return {
    fromDay: 1,
    toDay: 6,
  };
}
export function setCursorAtEnd(inputEl) {
  if (inputEl) {
    const {
      scrollWidth,
      scrollHeight,
      value: { length },
    } = inputEl;
    inputEl.setSelectionRange(length, length);
    inputEl.scrollLeft = scrollWidth;
    inputEl.scrollTop = scrollHeight;
  }
}

//TODO remove once the bug from MFGEU12-696 has been fixed in the Bryntum components
export function getIsoWeekNumber(startOfWeekDate){
  /*getWeek() was developed by Nick Baicoianu at MeanFreePath: http://www.epoch-calendar.com */
  //var dowOffset = startOfWeekDate.getDay();
  var dowOffset = 1; //ISO standard is start at Monday , any other offset gives weird results
  var newYear = new Date(startOfWeekDate.getFullYear(),0,1);
  var day = newYear.getDay() - dowOffset; //the day of week the year begins on
  day = (day >= 0 ? day : day + 7);
  var daynum = Math.floor((startOfWeekDate.getTime() - newYear.getTime() - 
  (startOfWeekDate.getTimezoneOffset()-newYear.getTimezoneOffset())*60000)/86400000) + 1;
  var weeknum;
  //if the year starts before the middle of a week
  if(day < 4) {
    weeknum = Math.floor((daynum+day-1)/7) + 1;
    if(weeknum > 52) {
      var nYear = new Date(startOfWeekDate.getFullYear() + 1,0,1);
      var nday = nYear.getDay() - dowOffset;
      nday = nday >= 0 ? nday : nday + 7;
      /*if the next year starts before the middle of
        the week, it is week #1 of that year*/
      weeknum = nday < 4 ? 1 : 53;
    }
  }
  else {
    weeknum = Math.floor((daynum+day-1)/7);
  }
  return weeknum;
}

export function showSnackBarMessage(component, msg, refreshButton) {
  component.props.dispatch(
    snackbar.actions.add({
      id: "save-error-alert",
      severity: "warning",
      message: (
        <Box display="flex" alignItems="center">
          {msg}&nbsp;&nbsp;
          {refreshButton &&
            <Button size="small" variant="contained" color="secondary" onClick={refreshButton}>
              {translate("Refresh")}
            </Button>}
        </Box>
      ),
    })
  );
}

export function checkResources (component, resources)  {
  let resourcesWithoutCalendar = 0;
  let msg;
  let firstResourceName;
  resources.forEach((i) => {
    if (i.calendar == "EmptyCalendar") {
      resourcesWithoutCalendar++;
      if (resourcesWithoutCalendar == 1) {
        firstResourceName = i.name;   
      }
    }
  });

  if (resourcesWithoutCalendar > 1) {
    msg = translate("multipleMissingCalendar", {
      resourceName: firstResourceName,
      missingCount: resourcesWithoutCalendar-1,
    });
  } else if (resourcesWithoutCalendar == 1) {
    msg = translate("singleMissingCalendar", {
      resourceName: firstResourceName
    });
  }
  if (msg) {
    showSnackBarMessage(component, msg, false);
  }
}
